module.exports = __webpack_public_path__ + "img/icon_vip_own_status.c55ec30e.png";